
import { css } from 'lit';
export default css`
.icon-card {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(232, 194, 255, var(--tw-border-opacity));
  height: calc(100% - 40px);
  margin-top: 40px;
}

  .icon-card__wrapper {
  display: flex;
}

  .icon-card__wrapper {
  height: 100%;
}

  .icon-card__wrapper {
  flex-direction: column;
}

  .icon-card__wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .icon-card__icon {
  margin-bottom: 1.5rem;
}

  .icon-card__icon {
  height: 5rem;
}

  .icon-card__icon {
  width: 5rem;
}

  .icon-card__icon {
  align-self: center;
}

  .icon-card__icon {
  border-radius: 9999px;
}

  .icon-card__icon {
  border-width: 1px;
}

  .icon-card__icon {
  --tw-border-opacity: 1;
  border-color: rgba(232, 194, 255, var(--tw-border-opacity));
}

  .icon-card__icon {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .icon-card__icon {
  padding: 1.5rem;
}

  .icon-card__icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .icon-card__icon {
    margin-top: -40px;
  }

  .icon-card__title {
  margin-left: 2rem;
  margin-right: 2rem;
}

  .icon-card__title {
  margin-bottom: 0.5rem;
}

  @media (min-width: 768px) {

  .icon-card__title {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

  @media (min-width: 768px) {

  .icon-card__title {
    margin-bottom: 0.75rem;
  }
}

  @media (min-width: 1024px) {

  .icon-card__title {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

  .icon-card__body-text {
  margin-left: 2rem;
  margin-right: 2rem;
}

  .icon-card__body-text {
  margin-bottom: 0.75rem;
}

  @media (min-width: 768px) {

  .icon-card__body-text {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

  @media (min-width: 1024px) {

  .icon-card__body-text {
    margin-left: 2rem;
    margin-right: 2rem;
  }
}

  .icon-card__link {
  margin-bottom: 0px;
}

  .icon-card__link {
  margin-right: 0px;
}

  .icon-card__link {
  margin-top: auto;
}

  .icon-card__link {
  display: flex;
}

  .icon-card__link {
  align-content: flex-end;
}

  .icon-card__link {
  justify-content: flex-end;
}

  .icon-card__link-text {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

  .icon-card__link-text {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

  .icon-card__link-text {
  align-self: center;
}

  .icon-card__link-text {
  text-align: right;
}

  .icon-card__link-text {
  font-size: 1.125rem;
}

  .icon-card__link-text {
  font-weight: 700;
}

  .icon-card__link-text {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .icon-card__link-text {
    line-height: 22px;
  }

  .icon-card__anchor {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .icon-card__link-text {
  margin-right: 0.75rem;
}

  .icon-card__link-text {
  align-self: center;
}

  .icon-card__link-text {
  font-size: 1.125rem;
}

  .icon-card__link-text {
  font-weight: 700;
}

  .icon-card__link-text {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .icon-card__link-icon {
  display: flex;
}

  .icon-card__link-icon {
  align-items: center;
}

  .icon-card__link-icon {
  justify-content: center;
}

  .icon-card__link-icon {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .icon-card__link-icon {
  padding: 1rem;
}

  .icon-card__link-icon {
  text-align: center;
}

  .icon-card__link-icon {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .icon-card--default .icon-card__wrapper:hover {
  --tw-shadow: 0 0 36px 0px rgba(0,0,0,0.16);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .icon-card--default .icon-card__wrapper:hover .icon-card__link-text {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .icon-card--default .icon-card__wrapper:hover .icon-card__link-icon {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

  .icon-card .icon-card__icon[name="number-1"] {
    width: 4.85rem;
    height: 4.85rem;
  }

  .icon-card .icon-card__icon[name^="number"] {
    padding: 1.45rem 1.85rem;
  }

  .icon-card--steps .icon-card__body-text {
      margin-bottom: 1.5rem;
    }

  .icon-card--inverted-colors .icon-card__wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .icon-card--inverted-colors .icon-card__wrapper {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .icon-card--inverted-colors .icon-card__link-icon {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .icon-card--inverted-colors .icon-card__link-icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .icon-card--inverted-colors .icon-card__link-text {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .icon-card--inverted-colors:hover .icon-card__link-icon {
        box-shadow: 0 0 50px -10px rgba(255, 255, 255, 0.7);
      }

  .icon-card:hover {
    box-shadow: 0 0 50px -10px rgba(107, 31, 153, 0.2);
  }

.btn__icon {
  margin-left: 2px;
  display: inline-block;
  height: 1rem;
  width: 1rem;
}
`;